<div class="container my-3 py-0 px-4">
    <div class="row m-0">
        <div class="col-auto">
            <div [ngClass]="{'font-weight-bold': true}">{{'CourtEventDetails.CourtClassPlayersLbl' | translate}}</div>
        </div>
    </div>
    <div class="row mt-1">
        <div class="col">
            <div *ngFor="let player of players; let i = index; let first = first; let last = last">
                <div class="row">
                    <div class="col">
                        <div class="row m-0 p-0 py-1 align-items-center justify-content-start">
                            <div class="col-1">
                                <app-initials-circle [name]="player.fullName"></app-initials-circle>
                            </div>
                            <div class="col-2">
                                <div class="row m-0 p-0 justify-content-start">
                                    <div class="col font-weight-bold">{{player.fullName}}</div>
                                    <div class="w-100"></div>
                                    <div class="col mt-1">
                                        <app-member-status-badge [memberStatusLabel]="player.memberStatusLabel"></app-member-status-badge>
                                    </div>
                                    <div class="w-100"></div>
                                    <div class="col">ID: {{player.memberId}}</div>
                                    <div class="w-100" *ngIf="player.membershipTypeDescription"></div>
                                    <div class="col" *ngIf="player.membershipTypeDescription">Type: {{player.membershipTypeDescription}}</div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row">
                                    <div class="col">{{player.phoneNumber | phoneMask}}</div>
                                    <div class="w-100"></div>
                                    <div class="col">{{player.email}}</div>
                                </div>
                            </div>
                            <div class="col-1">
                                <app-court-event-status-pill [status]="player.status"></app-court-event-status-pill>
                            </div>
                            <div class="col-1"></div>
                            <div class="col-2">
                                <div *ngIf="canShowChangePlayer(player)" class="text-center clickable black-gray" translate (click)="changePlayer(player.personId)" >
                                    CourtBooking.PlayerChange
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="text-center clickable bay-club-light-blue" translate (click)="checkInPlayer(player.personId)" *ngIf="player.isCheckInAvailable">
                                    CourtBooking.PlayerCheckIn
                                </div>
                            </div>
                        </div>

                        <div class="row no-gutters py-0 px-3" *ngIf="!last">
                            <div class="col-12">
                                <hr class="solid bg-yellow"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
